import React from 'react';
import { IconContainer } from './IconContainer';

const AddContractIcon = (props) => {
    return (
        <IconContainer ariaLabel="contracts" cursor="pointer" { ...props }>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.5 3.32502C17.5 2.41502 16.7558 1.66669 15.8375 1.66669H2.5V11.6667H4.16667V3.33335H5.83333V11.6667H7.5V3.33335H15.8333V16.6667L9.16667 16.675V18.3334H15.8375C16.7558 18.3334 17.5 17.5909 17.5 16.675V3.32502Z" fill="currentColor"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M20 13.3333V10H18.3333V13.3333H20ZM20 8.33333V5H18.3333V8.33333H20Z" fill="currentColor"/>
                <path d="M5.83332 12.5H4.16666V15H1.66666V16.6667H4.16666V19.1667H5.83332V16.6667H8.33332V15H5.83332V12.5Z" fill="currentColor"/>
            </svg>
        </IconContainer>
    )
}

export { AddContractIcon };